import { useTranslation } from 'react-i18next';

import i18n from '~/shared/lib/i18n';

import en from './locales/en.json';
import ru from './locales/ru.json';

const scopeName = 'widgets/PaymentMethod/ui/PaymentByCard/components/Form';

i18n.addResourceBundle('en', scopeName, en);
i18n.addResourceBundle('ru', scopeName, ru);

export const useLocalization = () => {
  return useTranslation(scopeName);
};
